import React, { ChangeEvent, FocusEvent } from 'react';

import './CustomInput.scss';

interface Props {
  label: string;
  placeholder?: string;
  endLabel?: string;
  width?: string | number;
  value?: string | number | undefined;
  type?: React.HTMLInputTypeAttribute;
  id?: string;
  name?: string;
  disabled?: boolean;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: FocusEvent<HTMLInputElement>) => void;
}

export const CustomInput = ({
  label,
  placeholder,
  width,
  endLabel,
  value,
  type,
  id,
  name,
  disabled,
  onChange,
  onBlur,
}: Props) => {
  return (
    <div className="custom-input-container">
      <div className="label-box">
        <p className="label__text">{label}</p>
        {endLabel && <p className="label__text_red">{endLabel}</p>}
      </div>

      <input
        id={id}
        name={name}
        className="custom-input"
        type={type || 'text'}
        placeholder={placeholder}
        style={{ width }}
        value={value}
        disabled={disabled}
        onChange={onChange}
        onBlur={onBlur}
      />
    </div>
  );
};
